import { usePositionOptions } from "@/services/backend/omni/position/lib/use-position-options";
import { PositionsTable } from "../../position/components/positions-table";
import { ScopeOfWork } from "../../scope-of-work/types/scope-of-work";
import { useContractScopeOfWorkPositionsProps } from "../lib/use-contract-scope-of-work-positions-props";
import { Contract } from "../types/contract";
import { omniPositionsTableConfig } from "../../servicekindrules/omni-positions-table-config";

/**
 * ContractScopeOfWorkPositionsTable shows and edits the positions of a scope
 * of work of the contract.
 */
export function ContractScopeOfWorkPositionsTable({
  contract,
  scopeOfWork,
}: {
  contract: Contract;
  scopeOfWork: ScopeOfWork;
}) {
  const props = useContractScopeOfWorkPositionsProps(contract, scopeOfWork);
  const options = usePositionOptions(
    contract.companyId,
    contract.serviceKind,
    scopeOfWork.serviceVariation,
  );

  return (
    <PositionsTable
      config={omniPositionsTableConfig(scopeOfWork.positions, options)}
      {...props}
    />
  );
}
